(() => {
  if (customElements.get('aplovio-footer-disclosure')) return;
  class FooterDisclosure extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const {signal} = this.abort;
      this.toggle = this.querySelector(':scope > [data-footer-toggle]');
      this.heading = this.querySelector(':scope > [data-footer-heading]');
      this.panel = this.querySelector(':scope > [data-footer-panel]');
      if (!this.toggle || !this.heading || !this.panel) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.open = this.open ?? (this.dataset.initialOpen === 'true');
      this.toggle.addEventListener('click', () => { this.open = !this.open; this.sync(true); }, {signal});
      this.mobile.addEventListener('change', () => this.sync(false), {signal});
      this.reduced.addEventListener('change', () => this.sync(false), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (event.target instanceof Element && (this.contains(event.target) || event.target.contains(this))) { this.open = true; this.sync(false); }
      }, {signal});
      this.sync(false);
    }
    disconnectedCallback() { this.abort?.abort(); this.animation?.cancel(); }
    sync(animate) {
      const expanded = !this.mobile.matches || this.open;
      // Initial and breakpoint states need no geometry or motion-style reads.
      // Read the animation's starting state before changing visibility.
      const style = animate && !this.reduced.matches ? getComputedStyle(this) : null;
      const token = style?.getPropertyValue('--ap-motion').trim() || '';
      const duration = token.endsWith('ms') ? parseFloat(token) : parseFloat(token) * 1000;
      const animated = !!style && Number.isFinite(duration) && duration > 0;
      const easing = style?.getPropertyValue('--ap-ease').trim() || 'ease-out';
      const height = animated ? this.panel.getBoundingClientRect().height : 0;
      this.animation?.cancel();
      this.animation = null;
      if (!expanded && this.panel.contains(document.activeElement)) this.toggle.focus({preventScroll: true});
      if (!this.mobile.matches && document.activeElement === this.toggle) {
        this.heading.hidden = false;
        this.heading.tabIndex = -1;
        this.heading.focus({preventScroll: true});
      }
      this.toggle.hidden = !this.mobile.matches;
      this.heading.hidden = this.mobile.matches;
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.panel.inert = !expanded;
      this.panel.hidden = false;
      if (!animated) {
        this.panel.hidden = !expanded;
        return;
      }
      const end = expanded ? this.panel.scrollHeight : 0;
      const motion = this.panel.animate([{height: `${height}px`, opacity: expanded ? .5 : 1, overflow: 'hidden'}, {height: `${end}px`, opacity: expanded ? 1 : 0, overflow: 'hidden'}], {duration, easing, fill: 'both'});
      this.animation = motion;
      motion.finished.then(() => {
        if (this.animation !== motion) return;
        this.panel.hidden = !expanded;
        motion.cancel();
        this.animation = null;
      }).catch(() => {});
    }
  }
  customElements.define('aplovio-footer-disclosure', FooterDisclosure);
})();
